import { GridActionType } from "./../../types/common";

export const isGridActionType = (value: string): value is GridActionType => {
  return [
    "edit",
    "view",
    "copy",
    "new",
    "hidden",
    "double-click",
    "permission",
    "new-sibling",
    "notes",
    "send-reply",
    "view-replies",
    "tag"
  ].includes(value);
};
